import api from 'api';

const url = id => `/api/active-reservation?event=${id}`;
export const fetch = id => api.get({path: url(id)});

export default {
    fetch
}
